var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.5,
    rx: 4.5,
    ry: 5.4,
    width: 9,
    height: 27,
    fill: "#5800ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8s",
    begin: "-0.6857142857142857s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.5,
    rx: 4.5,
    ry: 5.4,
    width: 9,
    height: 27,
    fill: "#5800ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8s",
    begin: "-0.5714285714285714s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.5,
    rx: 4.5,
    ry: 5.4,
    width: 9,
    height: 27,
    fill: "#5800ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8s",
    begin: "-0.45714285714285713s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.5,
    rx: 4.5,
    ry: 5.4,
    width: 9,
    height: 27,
    fill: "#5800ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8s",
    begin: "-0.34285714285714286s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.5,
    rx: 4.5,
    ry: 5.4,
    width: 9,
    height: 27,
    fill: "#5800ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8s",
    begin: "-0.22857142857142856s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.5,
    rx: 4.5,
    ry: 5.4,
    width: 9,
    height: 27,
    fill: "#5800ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8s",
    begin: "-0.11428571428571428s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.5,
    rx: 4.5,
    ry: 5.4,
    width: 9,
    height: 27,
    fill: "#5800ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerPrimary);
export default __webpack_public_path__ + "static/media/spinner-primary.20a39e05facda98d28701c71cd771bf8.svg";
export { ForwardRef as ReactComponent };